<template>
  <div>
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap class="mb-5">
        <v-flex xs12>
          <div class="text-xs-center">
            <h1 class="mb-4">online loan enquiry</h1>
            <v-fade-transition>
              <tumi-avatar v-show="isReady"></tumi-avatar>
            </v-fade-transition>
          </div>
        </v-flex>
        <v-flex xs12 md8 offset-md2>
          <v-fade-transition>
            <div class="message-wrapper" v-show="isReady">

              <vue-typed-js v-if="isValid"
                :strings="['Hi, I’m here to help with your online loan enquiry.<br/>Once you’ve completed it, we’ll do a few checks to find which loan<br/>providers could be your best fit.']"
                :typeSpeed="15"
              >
                <p class="typing message mb-0" v-show="valid && !isLoading"></p>
              </vue-typed-js>

              <p v-show="!valid" class="message mb-0">
                Oops you’ve missed a few details.<br/>
                Please complete the fields highlighted below and re-submit.
              </p>

              <p v-show="!isValid" v-html="errorMessage" class="message mb-0"></p>
              <div v-show="isLoading">
                <p class="message">
                  Hey {{firstName}},<br/> We're busy loading some things, thanks for your patience :)
                </p>
                <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                      <stop stop-color="#77787b" stop-opacity="0" offset="0%"></stop>
                      <stop stop-color="#77787b" stop-opacity=".631" offset="63.146%"></stop>
                      <stop stop-color="#77787b" offset="100%"></stop>
                    </linearGradient>
                  </defs>
                  <g fill="none" fill-rule="evenodd">
                    <g transform="translate(1 1)">
                      <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2">
                        <animateTransform
                          attributeName="transform"
                          type="rotate"
                          from="0 18 18"
                          to="360 18 18"
                          dur="0.9s"
                          repeatCount="indefinite"></animateTransform>
                      </path>
                      <circle fill="#fff" cx="36" cy="18" r="1">
                        <animateTransform
                          attributeName="transform"
                          type="rotate"
                          from="0 18 18"
                          to="360 18 18"
                          dur="0.9s"
                          repeatCount="indefinite"></animateTransform>
                      </circle>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </v-fade-transition>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-fade-transition>
            <v-form ref="form" v-show="formReady" v-model="valid" lazy-validation class="white--text">
              <v-layout row wrap class="mb-5">
                <v-flex xs12 md5>
                  <v-text-field :rules="firstNameRules"
                                color="white"
                                label="First name"
                                required
                                v-model="firstName"
                  ></v-text-field>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs12 md5>
                  <v-text-field color="white"
                                v-model="surname"
                                :rules="surnameRules"
                                label="Surname"
                                required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 md5>
                  <v-text-field color="white"
                                v-model="email"
                                :rules="emailRules"
                                label="Email address"
                                required
                  ></v-text-field>
                </v-flex>
                <v-spacer/>
                <v-flex xs12 md5>
                  <v-text-field color="white"
                                type="number"
                                v-model="ID"
                                :rules="IDRules"
                                :counter="13"
                                label="ID number"
                                dark
                                required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 md5>
                  <v-text-field color="white"
                                dark
                                type="tel"
                                v-model="cell"
                                :rules="cellRules"
                                :counter="10"
                                label="Cellphone number"
                                required
                  ></v-text-field>
                </v-flex>
                <v-spacer/>
                <v-flex xs12 md5>
                  <v-text-field color="white"
                                type="number"
                                max="250000"
                                v-model="loanAmount"
                                :rules="loanAmountRules"
                                label="Loan value"
                                prefix="R"
                                required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 md5>
                  <v-select
                    :items="typesOfEmployment"
                    :rules="typesOfEmploymentRules"
                    v-model="typeOfEmployment"
                    label="Type of employment"
                    color="white"
                    required
                    light
                    appendIcon="keyboard_arrow_down">
                    <template slot="data">
                      <div style="background: black">
                        HELLO?
                      </div>
                    </template>
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center justify-center>
                <v-flex xs12>
                 <!--<p>TICKING "I CONSENT" BELOW INDICATES THAT YOU ARE 18 YEARS OF AGE OR OLDER AND AGREE TO THESE <a
                    class="white--text"
                    href="https://www.virginmoney.co.za/loans-terms-conditions/" style="text-decoration: underline;"
                    target="_blank">TERMS</a></p>-->
                  <p>BY CLICKING ON THE TS&CS BELOW, YOU CONFIRM THAT YOU'RE 18 YEARS OR OLDER AND AGREE TO OUR NO-FUNNY-BUSINESS <a
                          class="white--text"
                          href="https://www.virginmoney.co.za/loans-terms-conditions/" style="text-decoration: underline;"
                          target="_blank">TERMS</a>.</p>
                </v-flex>
                <v-flex xs12 md8 offset-md2 text-xs-center>
                  <v-checkbox dark
                              v-model="creditConsent"
                              :rules="creditConsentRules"
                              color="white"
                              label="I agree to the terms & conditions and give my consent to Virgin Money Africa (Pty) Ltd using my personal details to perform a credit bureau enquiry."
                              required
                  ></v-checkbox>
                </v-flex>
              </v-layout>

              <hr class="my-5">

              <v-layout row wrap align-center justify-center>
                <v-flex shrink>
                  <vue-recaptcha
                    ref="invisibleRecaptcha"
                    @verify="onVerify"
                    @expired="onExpired"
                    size="invisible"
                    :sitekey="sitekey">
                  </vue-recaptcha>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12 mb-5>
                  <div v-if="isLoading">
                    <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"
                         class="button-loader">
                      <defs>
                        <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                          <stop stop-color="#77787b" stop-opacity="0" offset="0%"></stop>
                          <stop stop-color="#77787b" stop-opacity=".631" offset="63.146%"></stop>
                          <stop stop-color="#77787b" offset="100%"></stop>
                        </linearGradient>
                      </defs>
                      <g fill="none" fill-rule="evenodd">
                        <g transform="translate(1 1)">
                          <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2">
                            <animateTransform
                              attributeName="transform"
                              type="rotate"
                              from="0 18 18"
                              to="360 18 18"
                              dur="0.9s"
                              repeatCount="indefinite"></animateTransform>
                          </path>
                          <circle fill="#fff" cx="36" cy="18" r="1">
                            <animateTransform
                              attributeName="transform"
                              type="rotate"
                              from="0 18 18"
                              to="360 18 18"
                              dur="0.9s"
                              repeatCount="indefinite"></animateTransform>
                          </circle>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <v-btn v-else
                         class="submit-button"
                         @click="submit"
                  >
                    Confirm
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-fade-transition>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha'
  import moment from 'moment'
  import axios from 'axios'
  import md5 from 'md5'
  import { parsePhoneNumberFromString } from 'libphonenumber-js'

  import store from '../store'

  export default {
    name: 'step1',
    data: () => ({
      isValid: true,
      errorMessage: '',
      verified: false,
      avatarImage: '/img/tumi/tumi.jpg',
      isReady: false,
      formReady: false,
      valid: true,
      firstName: store.state.firstName,
      isLoading: false,
      firstNameRules: [
        v => !!v || 'Don’t be shy we need to know your name',
        v => !/[0-9]/.test(v) || 'Please add text only'
      ],
      surname: store.state.surname,
      surnameRules: [
        v => !!v || 'Without this we won’t know who you are',
        v => !/[0-9]/.test(v) || 'Please add text only'
      ],
      email: store.state.email,
      emailRules: [
        v => !!v || 'Without this we won’t know who you are',
        v => /.+@.+..+/.test(v) || 'Please provide a valid email address'
      ],
      ID: store.state.ID,
      IDRules: [
        v => !!v || 'This is your 13-digit South African ID number',
        v => (v && /^\d{6,13}$/.test(v)) || 'This is your 13-digit South African ID number',
        v => (moment(v.substring(0, 6), 'YYMMDD')
          .isValid()) || 'Please check if you entered your ID correctly',
        v => (moment.duration(moment()
          .diff(moment((parseInt(v.substring(0, 2)) > parseInt(moment()
            .format('YY')) ? '19' : '20') + v.substring(0, 6), 'YYYYMMDD')))
          .asYears() >= 18) || 'You need to be 18 or older to apply for a loan',
        v => (v.length > 10) || 'This is your 13-digit South African ID number',
        v => (/^\d{10}[0-1]/.test(v)) || 'Please check if you entered your ID correctly',
        v => {
          if (!(/^\d{13}$/.test(v))) {
            return 'This is your 13-digit South African ID number'
          }
          const control = v.charAt(12)
          let first = 0
          let interim = 0
          for (let i = 0; i < 6; i++) {
            interim = interim * 10 + parseInt(v.charAt(i * 2 + 1))
            first += parseInt(v.charAt(i * 2))
          }

          interim *= 2

          let res = 0
          String(interim)
            .split('')
            .forEach(i => {
              res += parseInt(i)
            })

          const check = String(res + first)

          return parseInt(control) === 10 - (parseInt(check[check.length - 1]) || 10) || 'Please check if you entered your ID correctly'
        }
      ],
      cell: store.state.cell,
      cellRules: [
        v => (v && v.length >= 10) || 'This is your 10-digit cellphone number eg. 071 234 5678',
        v => (!!parsePhoneNumberFromString(v, 'ZA') && parsePhoneNumberFromString(v, 'ZA')
          .isValid()) || 'Please provide a valid cellphone number'
      ],
      creditReason: store.state.creditReason,
      creditReasons: [
        {
          text: 'Housing',
          value: 'HOUSING'
        },
        {
          text: 'Home improvements and repairs',
          value: 'HOME_IMPROVEMENTS_AND_REPAIRS'
        },
        {
          text: 'Furniture and household equipment',
          value: 'FURNITURE_AND_HOUSEHOLD_EQUIPMENT'
        },
        {
          text: 'Education loan',
          value: 'EDUCATION_LOAN'
        },
        {
          text: 'Small business',
          value: 'SMALL_BUSINESS'
        },
        {
          text: 'Service',
          value: 'SERVICE'
        },
        {
          text: 'Debt consolidation',
          value: 'DEBT_CONSOLIDATION'
        },
        {
          text: 'Other',
          value: 'OTHER'
        }
      ],
      creditReasonRules: [
        v => !!v || 'please choose an option'
      ],
      loanAmount: 120000,
      loanAmountRules: [
        v => (!!v && v >= 100 && v <= 250000) || 'This can be an amount between R100 and R250 000'
      ],
      typeOfEmployment: store.state.typeOfEmployment,
      typesOfEmployment: ['Permanent', 'Contract', 'Self-employed', 'Other'],
      typesOfEmploymentRules: [
        v => !!v || 'Please choose an option'
      ],
      loanTerm: 14,
      loanTermRules: [
        v => (!!v && v >= 3 && v <= 84) || 'How many months do you need to repay the loan? Between 3 and 84 months (7 years)'
      ],
      creditConsent: false,
      creditConsentRules: [
        v => !!v || 'Please tick the checkbox'
      ],
      sitekey: process.env.VUE_APP_SITEKEY || '6LfRubIUAAAAAAw23mDUZ3GsBBKIlTT1jSQSjkUa',
      recaptchaToken: '',
      referrer: process.env.VUE_APP_REFERRER
    }),
    components: {
      VueRecaptcha
    },
    computed: {
      isValidResponse() {
        return this.isValid
      }
    },
    methods: {
      submit() {
        if (this.$refs.form.validate()) {
          this.isLoading = true
          this.isValid = true
          if (this.verified) {
            this.saveData()
          } else {
            this.$refs.invisibleRecaptcha.execute()
          }
        }
      },
      onVerify(response) {
        if (response) {
          this.verified = true
          this.saveData(response)
        }
      },
      onExpired() {
        this.$refs.recaptcha.reset()
        this.verified = false
      },
      saveData(response) {
        store.commit('firstName', this.firstName)
        store.commit('surname', this.surname)
        store.commit('email', this.email)
        store.commit('ID', this.ID)
        store.commit('cell', parsePhoneNumberFromString(this.cell, 'ZA')
          .formatNational()
          .replace(/[^0-9]/g, ''))
        // store.commit('creditReason', this.creditReason)
        store.commit('loanAmount', this.loanAmount)
        // store.commit('loanTerm', this.loanTerm)
        store.commit('creditConsent', this.creditConsent)
        store.commit('termConsent', this.termConsent)
        store.commit('recaptchaToken', response)
        store.commit('referrer', this.referrer)

        axios.post(`${store.state.apiUrl}/loans/register_initial_lead`, {
          first_name: store.state.firstName,
          last_name: store.state.surname,
          email: store.state.email,
          id_number: store.state.ID,
          mobile_number: store.state.cell,
          // credit_reason: store.state.creditReason,
          loan_amount: store.state.loanAmount,
          // loan_term: store.state.loanTerm,
          credit_consent: store.state.creditConsent,
          term_consent: store.state.termConsent,
          referrer: store.state.referrer
        })
          .then(res => {
            this.loadingScreen = false

            store.commit('questionData', res.data.message.return_data.question_data)
            store.commit('questionStatusCode', res.data.message.return_data.status_code)
            store.commit('transactionId', res.data.message.return_data.transaction_id)

            if ((res.data.message.return_data.status_code === 'TSCKR') || (res.data.message.return_data.status_code === 'TSCSL')) {
              this.errorMessage = 'Weird. Your identity information and answers don\'t add up. For support please reach out to us on <a style="text-decoration: underline; color: #1eb887;" href="mailto: support@virginmoney.co.za">support@virginmoney.co.za</a>'
              this.isLoading = false
              this.isValid = false
              return
            }

            // console.log(res)
            // store.commit('userId', res.data.message.original.message.user_id);
            // store.commit('creditScore', res.data.message.original.message.credit_score);
            // this.$mixpanel.track("Auth successful");

            // this.$mixpanel.people.set({
            //   "$MaritalStatus": this.marriageStatus,
            //   "$PostalCode": this.postalCode,
            //   "$CreditScore": res.data.message.original.message.credit_score,
            // })

            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              userId: res.data.uid,
              uid: res.data.uid,
              event: 'registered'
            })
            const oldStr = new String(store.state.cell) // eslint-disable-line
            const newStr = oldStr.replace(oldStr.charAt(0), '+27')

            /* eslint-disable */
            this.$mixpanel.track("Step 1: Complete", {
              "BureauConsent": this.creditConsent,
              "TermsAndConditions": this.creditConsent,
            });
            this.$mixpanel.alias(md5(this.ID))
            this.$mixpanel.identify(md5(this.ID))
            this.$mixpanel.people.set({
              'IDNumber': md5(this.ID),
              '$first_name': this.firstName,
              '$last_name': this.surname,
              '$name': this.firstName + ' ' + this.surname,
              '$phone': newStr,
              '$email': this.email,
              'EmploymentStatus': this.typeOfEmployment
            })
            /* eslint-enable */
            this.$router.push({
              path: '/auth'
            })
          }).catch(er => {
            this.isLoading = false
            console.log(er)
          })
      },
      mouseIsMoving(event) {
        // console.log(event);
        const headPosition = document.querySelector('#movingHead')
          .getBoundingClientRect()
        const aboveHead = event.clientY < headPosition.top
        const belowHead = event.clientY > headPosition.bottom
        const leftOfHead = event.clientX < headPosition.left
        const rightOfHead = event.clientX > headPosition.right
        if (aboveHead && leftOfHead) {
          this.avatarImage = '/img/tumi/looking-top-left.jpg'
        } else if (aboveHead && rightOfHead) {
          this.avatarImage = '/img/tumi/looking-top-right.jpg'
        } else if (aboveHead) {
          this.avatarImage = '/img/tumi/looking-up.jpg'
        } else if (belowHead && leftOfHead) {
          this.avatarImage = '/img/tumi/looking-bottom-left.jpg'
        } else if (belowHead && rightOfHead) {
          this.avatarImage = '/img/tumi/looking-bottom-right.jpg'
        } else if (belowHead) {
          this.avatarImage = '/img/tumi/looking-down.jpg'
        } else if (leftOfHead) {
          this.avatarImage = '/img/tumi/looking-left.jpg'
        } else if (rightOfHead) {
          this.avatarImage = '/img/tumi/looking-right.jpg'
        } else {
          this.avatarImage = '/img/tumi/tumi.jpg'
        }
      },
      isMobile() {
        return window.screen.width <= 760
      }
    },
    mounted() {
      setTimeout(() => {
        this.isReady = true
      }, 500)
      setTimeout(() => {
        this.formReady = true
      }, 1500)

      this.$mixpanel.track('Page: Step 1') // eslint-disable-line

      window.addEventListener('mousemove', this.mouseIsMoving)
    },
    beforeCreate() {
      store.replaceState({
        apiUrl: process.env.VUE_APP_API_URL || 'https://credit-api.dev.virgin-money.wigroup.io/api/v1',
        firstName: '',
        surname: '',
        email: '',
        ID: '',
        cell: '',
        creditReason: '',
        loanAmount: '',
        loanTerm: '',
        typeOfEmployment: '',
        creditConsent: '',
        termConsent: '',
        postalCode: '',
        marriageStatus: '',
        companyName: '',
        startDate: '',
        employementType: '',
        endDate: '',
        occupation: '',
        salary: '',
        salaryTerm: '',
        historicAdvantage: '',
        recaptchaToken: '',
        creditScore: '',
        userId: '',
        callback: '',
        questionData: '',
        questionStatusCode: '',
        transactionId: '',
        referrer: ''
      })
      window.localStorage.clear()
    }
  }
</script>
